<template>
  <div class="group/tooltip relative inline-block">
    <slot />
    <span
      class="pointer-events-none absolute z-10 block w-max max-w-64 whitespace-normal break-words rounded border border-blue bg-blue-lighter px-2 py-1 text-xs opacity-0 transition-opacity group-hover/tooltip:opacity-100"
      :class="[tooltipPositionClass, customClass]"
      role="tooltip"
    >
      {{ text }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    text: string
    position?: 'top' | 'bottom' | 'left' | 'right'
    customClass?: string
  }>(),
  {
    position: 'bottom',
    customClass: '',
  },
)

const tooltipPositionClass = computed(() => {
  switch (props.position) {
    case 'top':
      return 'bottom-full left-1/2 -translate-x-1/2 mb-2'
    case 'left':
      return 'right-full top-1/2 -translate-y-1/2 mr-2'
    case 'right':
      return 'left-full top-1/2 -translate-y-1/2 ml-2'
    default:
      // Keep default placement below the trigger on all screen sizes.
      // Rendering to the left on small screens can clip the tooltip at the viewport edge.
      return 'top-full left-1/2 -translate-x-1/2 mt-2'
  }
})
</script>
